export const MicrosoftLogo = () => {
    return (
        <svg
            aria-label="Microsoft logo"
            width="24"
            height="24"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
        >
            <path d="M96 96H247V247H96" fill="#f24f23"></path>
            <path d="M265 96V247H416V96" fill="#7eba03"></path>
            <path d="M96 265H247V416H96" fill="#3ca4ef"></path>
            <path d="M265 265H416V416H265" fill="#f9ba00"></path>
        </svg>
    );
};
